import { Button, message, Space } from "antd"
import React, { useEffect, useState } from "react"
import RtMultipleSelect from "../../../ui/RtMultipleSelect"
import { multipleSelectOptions } from "../../../types/settings"
import customFilterService from "../../../services/customFilter.service"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"

const CustomFilters: React.FC = () => {
  const [optionNames, setOptionNames] = useState<multipleSelectOptions[]>([])
  const [filterIds, setFilterIds] = useState<string[]>([])
  const [isFiltersLoading, setIsFiltersLoading] = useState<boolean>(false)

  const { fetchSponsoredProductCampaigns } = useActions()
  const { dateRange, isOrder } = useTypedSelector((select) => select.filter)

  const getFilterData = async () => {
    setIsFiltersLoading(true)
    try {
      const customFilters = await customFilterService.getFilterData()
      if (customFilters) {
        setOptionNames(customFilters)
      } else {
        message.error("Failed to load custom filters")
      }
    } catch (_e) {
      message.error("Failed to load custom filters")
    } finally {
      setIsFiltersLoading(false)
    }
  }
  useEffect(() => {
    getFilterData()
  }, [])

  const handleSelectAllFilter = (selectedList): void => {
    setFilterIds(selectedList)
  }

  function filterApply() {
    fetchSponsoredProductCampaigns({
      startDate: dateRange.from,
      endDate: dateRange.to,
      filterIds: filterIds || [],
      isOrder,
    })
  }

  return (
    <Space.Compact>
      <RtMultipleSelect
        onChange={handleSelectAllFilter}
        options={optionNames}
        placeholder={"Custom settings"}
        loading={isFiltersLoading}
      />
      <Button onClick={() => filterApply()}>Apply</Button>
    </Space.Compact>
  )
}

export default CustomFilters
